import script from "./OnlineChatForwardClientToOperatorBlockPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineChatForwardClientToOperatorBlockPreview.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineChatForwardClientToOperatorBlockPreview.vue?vue&type=style&index=0&id=00da9f3a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00da9f3a"]])

export default __exports__